import { Button } from '@app/components/various/Button';
import { Download, FillScreen, FitToScreen, ZoomIn, ZoomOut } from '@app/components/various/Icons';

interface Props {
  onZoomIn: VoidFunction;
  onZoomOut: VoidFunction;
  onZoomReset: VoidFunction;
  onZoomFill: VoidFunction;
  onDownload: VoidFunction;
  zoom: number;
  isZoomInDisabled: boolean;
  isZoomOutDisabled: boolean;
}

export const GalleryControls = ({
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onZoomFill,
  isZoomInDisabled = false,
  isZoomOutDisabled = false,
  onDownload,
  zoom,
}: Props) => {
  return (
    <div className="fixed right-4 top-0 z-overlay flex h-full items-center">
      <div className="flex flex-col gap-1">
        <Button icon={ZoomIn} color="secondary" onClick={onZoomIn} disabled={isZoomInDisabled} />
        <Button icon={ZoomOut} color="secondary" onClick={onZoomOut} disabled={isZoomOutDisabled} />
        {zoom > 1 ?
          <Button icon={FitToScreen} color="secondary" onClick={onZoomReset} />
        : <Button icon={FillScreen} color="secondary" onClick={onZoomFill} />}
        <Button icon={Download} color="secondary" onClick={onDownload} />
      </div>
    </div>
  );
};
